<template>
  <div class="video-player-container">
    <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto" width="100%" height="100%"></video>
  </div>
</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-hls';

export default {
  name: 'VideoPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    src: {
      type: String,
      required: true
    },
    poster: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      player: null
    };
  },
  mounted() {
    this.initializePlayer();
  },
  beforeUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  },
  watch: {
    src(newSrc) {
      if (this.player && newSrc) {
        this.player.src({ src: newSrc, type: 'application/x-mpegURL' });
        this.player.load(); // Load the new source
        // Optionally play the video automatically
        this.player.play();
      }
    }
  },
  methods: {
    initializePlayer() {
      const videoOptions = {
        ...this.options,
        poster: this.poster,
        sources: [
          {
            src: this.src,
            type: 'application/x-mpegURL'
          }
        ]
      };

      this.player = videojs(this.$refs.videoPlayer, videoOptions, () => {
        console.log('Video.js player is ready.');
        // You can add more event listeners or player setup here
      });

      // Handle errors
      this.player.on('error', () => {
        const error = this.player.error();
        console.error('Video.js player error:', error);
        if (error) {
          console.error('Error Code:', error.code);
          console.error('Error Message:', error.message);
          // Log additional details if available, e.g., status for network errors
          if (error.status) {
            console.error('HTTP Status:', error.status);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.video-player-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Ensure the video element fills the container */
.video-js {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain; /* Maintain aspect ratio */
}

/* Style adjustments for Video.js skin if needed */
.vjs-default-skin {
  /* Example: Customize control bar background */
  /* .vjs-control-bar { background-color: rgba(0, 0, 0, 0.7); } */
}
</style>
